export const TOPIC_CHANNEL_SLUG = 'topics';
export const TOPIC_CHANNEL_ID = 'topics';